var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customNav"},[(!_vm.isWx)?_c('van-nav-bar',{attrs:{"left-arrow":"","left-text":"返回"},on:{"click-left":_vm.onClickLeft}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }